import { render } from "./transfereListe.vue?vue&type=template&id=1fa38538&scoped=true"
import script from "./transfereListe.vue?vue&type=script&lang=js"
export * from "./transfereListe.vue?vue&type=script&lang=js"

import "./transfereListe.vue?vue&type=style&index=0&id=1fa38538&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa38538"]])

export default __exports__